import { useState, useEffect } from 'react';
export var getCurrentColorMode = function () {
    var htmlMode = document.documentElement.getAttribute('data-mode');
    if (htmlMode === 'light' || htmlMode === 'dark') {
        return htmlMode;
    }
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};
export var useColorMode = function () {
    var _a = useState(getCurrentColorMode), colorMode = _a[0], setColorMode = _a[1];
    var setMode = function (newMode) {
        setColorMode(newMode);
    };
    useEffect(function () {
        var mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        var handleChange = function () {
            setMode(mediaQuery.matches ? 'dark' : 'light');
        };
        mediaQuery.addEventListener('change', handleChange);
        return function () {
            mediaQuery.removeEventListener('change', handleChange);
        };
    }, [colorMode]);
    return {
        colorMode: colorMode,
        setColorMode: setMode,
        toggleColorMode: function () { return setMode(colorMode === 'light' ? 'dark' : 'light'); },
    };
};
